import { render, staticRenderFns } from "./betRanking.vue?vue&type=template&id=ed6c4d1c"
import script from "./betRanking.vue?vue&type=script&lang=js"
export * from "./betRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports